export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.bc588dbd.svg";